import statsService from '../services/stats.service'

const handlers = {
  winnings: {
    set: 'winnings_set'
  }
}

const initVuexState = function(state) {
  state.winnings = [];
}

const initGetters = function(getters) {
  getters.winnings = (state => state.winnings);
}

const initActions = function(actions) {
  actions[handlers.winnings.set] = ({ commit }, winnings) => commit(handlers.winnings.set, winnings);
}

const initMutations = function(mutations) {
  mutations[handlers.winnings.set] = (state, winnings) => state.winnings = winnings;
}

const winningsUpdatePeriod = 5000; // ms

let isWatchingWinnings = false;

const watchWinningsFunc = async function(state) {
  try {
    if (isWatchingWinnings) {
      state.winnings.set(await statsService.getWinnings());
    }
  } catch (e) {
    console.error('winnings receiving error');
    console.error(e);
  }
  if(isWatchingWinnings)
    setTimeout(() => watchWinningsFunc(state), winningsUpdatePeriod);
}

const initAppState = function(appState, store) {
  appState.winnings = {
    get: () => store.getters.winnings,
    set: winnings => store.dispatch(handlers.winnings.set, winnings),
    load: async () => {
      appState.winnings.set(await statsService.getWinnings());
    },
    watch: () => {
      if (!isWatchingWinnings) {
        isWatchingWinnings = true;
        watchWinningsFunc(appState);
      }
    },
    stopWatch: () => {
      isWatchingWinnings = false;
    }
  }
}

export default {
  initVuex(vuexState, getters, actions, mutations) {
    initVuexState(vuexState);
    initGetters(getters);
    initActions(actions);
    initMutations(mutations);
  },
  initAppState(appState, store) {
    initAppState(appState, store);
  }
}



// WEBPACK FOOTER //
// ./_common/data/winnings.js